import { render, staticRenderFns } from "./grinding-loads.html?vue&type=template&id=b8e5e480&scoped=true&"
import script from "./grinding-loads.ts?vue&type=script&lang=js&"
export * from "./grinding-loads.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8e5e480",
  null
  
)

export default component.exports